import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { RiExternalLinkLine } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { FaRegLightbulb } from "react-icons/fa6";
import { FiGlobe } from "react-icons/fi";
import { FiUsers } from "react-icons/fi";
import { HiOutlineSparkles } from "react-icons/hi";

const Partners = () => {
    return (
        <div>
            {/* Our partners Section 1 */}

            <div className='container mx-auto px-4'>
                <p className='text-2xl font-bold text-center tracking-tight text-[#d38f24] sm:text-3xl md:text-4xl mt-8 mb-6'>Collaborating for Excellence</p>
                <p className='text-3xl font-semibold text-[#0b1437] text-center'>Meet our esteemed partners who share our vision for innovation.</p>

                <div className='relative mx-auto max-w-4xl my-16'>
                    {/* <div className='flex items-center justify-center'> */}

                    <Slider
                        infinite={true}
                        speed={3000}
                        slidesToShow={4}
                        slidesToScroll={1}
                        autoplay={true}
                        autoplaySpeed={3000}
                        arrows={true}
                        cssEase='linear'
                        responsive={[
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    dots: true
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            }
                        ]}
                    >
                        <div className='flex items-center justify-center'>
                            <img src='https://cdn.pixabay.com/photo/2024/03/11/19/15/ai-generated-8627457_640.png' width={120} height={120} className='rounded-md mb-2'  alt='TechCorp logo'/>
                            <p className='text-lg font-semibold text-gray-800'>TechCorp</p>
                            <div className='flex items-center'>
                                <p className=' inline-flex items-center text-blue-600 hover:underline'>Visit Website</p>
                                <RiExternalLinkLine className='ml-1  text-lg' />
                            </div>

                        </div>

                        <div className='flex items-center justify-center'>
                            <img src='https://media.istockphoto.com/id/1979289147/photo/data-analysis-science-and-big-data-with-ai-technology-analyst-or-scientist-uses-a-computer.jpg?s=2048x2048&w=is&k=20&c=CnYhOjeTPisYsN-OLYVp60ZNKK3jP3JCPZrCjxCqmto=' width={120} height={120} className='rounded-md mb-2' alt='InnovateSoft team analyzing data'/>
                            <p className='text-lg font-semibold text-gray-800'>InnovateSoft</p>
                            <div className='flex items-center'>
                                <p className=' inline-flex items-center text-blue-600 hover:underline'>Visit Website</p>
                                <RiExternalLinkLine className='ml-1  text-lg' />
                            </div>

                        </div>

                        <div className='flex items-center justify-center'>
                            <img src='https://media.istockphoto.com/id/2148113350/photo/data-center-server-racks-it-modern-hardware-server-room-data-storage-center-database.jpg?s=2048x2048&w=is&k=20&c=RlMm4oKzMkZHeco4sGhBWJBANqAZmKeIjJnL4pB61AU=' width={120} height={120} className='rounded-md mb-2' alt='DataDynamics server racks'/>
                            <p className='text-lg font-semibold text-gray-800'>DataDynamics</p>
                            <div className='flex items-center'>
                                <p className=' inline-flex items-center text-blue-600 hover:underline'>Visit Website</p>
                                <RiExternalLinkLine className='ml-1  text-lg' />
                            </div>

                        </div>

                        <div className='flex items-center justify-center'>
                            <img src='https://media.istockphoto.com/id/1634086519/photo/human-and-robot-hands-forming-a-heart-shape-together-ai-and-human-collaboration-concept.webp?s=2048x2048&w=is&k=20&c=-I0yCzDijvY9TfJQzFeFOlMQHKMn_sR0IqGyOBcZ1SE=' width={120} height={120} className='rounded-md mb-2' alt='AIVision human and robot collaboration'/>
                            <p className='text-lg font-semibold text-gray-800'>AIVision</p>
                            <div className='flex items-center'>
                                <p className=' inline-flex items-center text-blue-600 hover:underline'>Visit Website</p>
                                <RiExternalLinkLine className='ml-1  text-lg' />
                            </div>

                        </div>

                    </Slider>

                    {/* </div> */}
                </div>


                <div className='mx-auto max-w-4xl text-center'>
                    <p className='text-xl text-gray-800 pb-9'>At QualBots, we believe that collaboration is key to driving innovation and delivering exceptional solutions. Our partners encompass a diverse range of industries and expertise, from technology providers to industry leaders. Together, we work towards creating cutting-edge automation solutions that cater to various sectors, including banking, healthcare, retail, and more.</p>
                </div>

                <div className='flex justify-center items-center pb-7'>
                    <button className='flex items-center text-xl bg-[#d38f24] hover:bg-[#0b1437] text-white font-semibold py-3 px-5 my-4 rounded-full'>
                        Explore Our Partnerships
                        <span> <FaChevronRight className='text-xl ml-2'/></span>
                    </button>

                </div>

            </div>

            {/* Our partners Section 2 */}

            <div className='bg-white'>

                <div>
                    <p className='text-2xl font-bold text-center tracking-tight text-[#d38f24] sm:text-3xl md:text-4xl pt-12 mb-8 '>The Benefits of Partnering with QualBots</p>
                    <p className='text-3xl font-semibold text-[#0b1437] text-center mb-8'>Unlock new opportunities and drive growth through collaboration.</p>
                    <p className='text-2xl text-gray-800 text-center mb-12'>Partnering with QualBots offers numerous advantages, including:</p>

                    <div className='grid gap-8 md:grid-cols-2 lg:grid-cols-4 mb-6 mx-10 pb-10'>
                        <div className='flex flex-col items-center rounded-lg bg-gray-50 p-6 shadow-lg transition-all hover:shadow-xl'>
                            <div className='mb-4 rounded-full bg-[#fcefd9] p-3'>
                                <FaRegLightbulb className='h-8 w-8 text-[#d38f24]'/>
                            </div>
                            <p className="mb-3 text-2xl font-semibold text-[#0b1437]">Access to Innovation</p>
                            <p className="mb-1 text-xl"> Leverage our cutting-edge technology to enhance your offerings.</p>
                        </div>

                        <div className='flex flex-col items-center rounded-lg bg-gray-50 p-6 shadow-lg transition-all hover:shadow-xl'>
                            <div className='mb-4 rounded-full bg-[#fcefd9] p-3'>
                                <FiGlobe className='h-8 w-8 text-[#d38f24]'/>
                            </div>
                            <p className="mb-3 text-2xl font-semibold text-[#0b1437]">Market Expansion</p>
                            <p className="mb-1 text-xl">Tap into new markets and customer segments through collaborative efforts.</p>
                        </div>

                        <div className='flex flex-col items-center rounded-lg bg-gray-50 p-6 shadow-lg transition-all hover:shadow-xl'>
                            <div className='mb-4 rounded-full bg-[#fcefd9] p-3'>
                                <FiUsers className='h-8 w-8 text-[#d38f24]'/>
                            </div>
                            <p className="mb-3 text-2xl font-semibold text-[#0b1437]">Shared Expertise</p>
                            <p className="mb-1 text-xl">Benefit from the collective knowledge and resources of our team and partners.</p>
                        </div>

                        <div className='flex flex-col items-center rounded-lg bg-gray-50 p-6 shadow-lg transition-all hover:shadow-xl'>
                            <div className='mb-4 rounded-full bg-[#fcefd9] p-3'>
                                <HiOutlineSparkles className='h-8 w-8 text-[#d38f24]'/>
                            </div>
                            <p className="mb-3 text-2xl font-semibold text-[#0b1437]">Enhanced Customer Solutions</p>
                            <p className="mb-1 text-xl">Deliver comprehensive solutions that address diverse client needs.</p>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default Partners